import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import LinearProgress from '@mui/material/LinearProgress';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import axios from 'axios'; 
import {API_URL} from '../utils/EnvVars';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 

  const [dataLoading, setDataLoading] = React.useState(true);
  const [filter, setFilter] = React.useState(false);
  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);

  var myCurrentDate=new Date();
	var myDueDate=new Date(myCurrentDate);
  myDueDate.setDate(myDueDate.getDate() - 90);
	const [startDate, setStartDate] = React.useState(moment(myDueDate).format('YYYY-MM-DD'));

  var myCurrentDateA=new Date();
	var myDueDateA=new Date(myCurrentDateA);
  myDueDateA.setDate(myDueDateA.getDate());
	const [endDate, setEndDate] = React.useState(moment(myDueDateA).format('YYYY-MM-DD'));

  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {		
		if(props.userObj && props.dataObj && open){
      setDataLoading(true);
			getApiData();
		}
	}, [props.userObj,props.dataObj, open, filter]);

  async function getApiData(){ 
    let startDateX = moment(startDate).format('YYYY-MM-DD');
    let endDateX = moment(endDate).format('YYYY-MM-DD');
    let apiUrl=API_URL+'/crm-report-details?id='+props.dataObj.autoId+'&startDate='+startDateX+'&endDate='+endDateX;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
        setDataLoading(false);
      if(response && response.data && response.data.responseTxt==="success"){  
        setColumns(response.data.columns);
        setRows(response.data.list);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      }
    })
  }

  function search(){
		setFilter(!filter);
	}


  return (
    <>
      <Dialog fullScreen style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-25px'}} onClose={handleClose}>{props.dataObj?props.dataObj.title:null}</DialogTitle>
          <DialogContent >
                <Box mt={1} mb={1} >
                    <Grid container spacing={2}>
                      <Grid item md={12} xs={12} >
                              <TextField 
                                label="Start Date"
                                id="date"                                
                                type="date"
                                defaultValue={startDate}
                                size="small"
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setStartDate(event.target.value)}
                                variant="outlined"
                                style={{marginRight: 6}}
                                />
                              <TextField 
                                label="End Date"
                                id="date"                                
                                type="date"
                                defaultValue={endDate}
                                size="small"
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setEndDate(event.target.value)}
                                variant="outlined"
                                style={{marginRight: 6}}
                                />

                              <Button onClick={() => {search()}} style={{marginTop:2,backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>
                          </Grid>
                        </Grid>
                    </Box>            

                    <div style={{ height: 430, width: '100%' }}>
                    {dataLoading?<LinearProgress />:null}
                   <DataGrid
                      rows={rows}
                      columns={columns}
                      pageSize={100}
                      rowHeight={40}
                      disableSelectionOnClick
                      rowsPerPageOptions={[100]}                      	
                      style={{fontSize:12}}
                      components={{
                        NoRowsOverlay: () => (
                          <Stack height="50%" style={{marginBottom: -100}} alignItems="center" justifyContent="center">
                          <span style={{color:'#FF0000',fontWeight:'bold'}}>No Records found!</span>
                          </Stack>
                        )}}	                      	
                    />
                    </div>
          </DialogContent>
      </Dialog>
        
    </>
  );

});

export default CustomizedDialogs;